/* import __COLOCATED_TEMPLATE__ from './annotations.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();